import React from "react";

import { Row, Col, Input, Select, Card } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/ContactUs/Branches/Branches.css";

import BranchesTable from "./BranchesTable.js";

const branchesCard = {
  borderRadius: "20px",
  backgroundColor: "#ededed",
  opacity: "95%",
  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
const thTable = {
  direction: "rtl",
  textAlign: "center",
  fontSize: ".8em",
  color: "#8d8d8d",
  fontFamily: "IranSans",
};
const thTableMobile = {
  direction: "rtl",
  textAlign: "center",
  fontSize: ".7em",
  color: "#8d8d8d",
  fontFamily: "IranSans",
};

const BranchesMain = (props) => {
  return props.size === "laptopdesktop" ? (
    <div className="BranchesBackground">
      <div style={{ paddingTop: "100px" }}>
        <Center>
          <p className="mainTitle mainTitleBorderRight mainTitleBorderLeft">
            <strong>شعب ایرانیان پوشش</strong>
          </p>
        </Center>
        <Center>
          <Margin top={2}>
            <p className="mainTitleDescription" style={{ color: "#fff" }}>
              فهرست شعبه های زیرمجوعه ایرانیان پوشش
            </p>
          </Margin>
        </Center>
      </div>
      <Row style={{ marginTop: "150px" }}>
        <Col span={2}></Col>
        <Col span={20}>
          <div style={branchesCard}>
            <table
              style={{
                fontFamily: "IranSans",
                borderCollapse: "separate",
                borderSpacing: "0 15px",
                paddingRight: "10px",
                paddingLeft: "10px",
              }}
            >
              <tr>
                <th style={thTable}>کد</th>
                <th style={thTable}>آدرس</th>
                <th style={thTable}>تلفن</th>
                <th style={thTable}>شهرستان</th>
                <th style={thTable}>استان</th>
              </tr>
              <BranchesTable
                ostan="تهران (شعبه مرکزی)"
                town="تهران"
                phone="۰۲۱-۸۴۲۲۹۰۰۰-۹۹۹"
                address="خیابان سیدجمال الدین اسدآبادی (یوسف آباد)، بن بست هفتم، پلاک ۱۴، ساختمان شرکت سهامی ایرانیان پوشش"
                code="400"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="تهران"
                town="تهران"
                phone="۰۲۱-۸۴۲۲۹۰۰۰-۹۹۹"
                address="خیابان ولیعصر، خیابان سید جمال الدین اسدآبادی(یوسف آباد) نبش کوچه چهارم پلاک 44"
                code=""
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="تهران"
                town="تهران"
                phone="۰۲۱-۸۴۲۲۹۰۰۰-۹۹۹"
                address="خ ولیعصر یوسف آباد میدان سلماس خ شهریار نبش کوچه 14(سپهری) پلاک 39"
                code="-"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="تهران"
                town="تهران"
                phone="۰۲۱-۸۴۲۲۹۰۰۰-۹۹۹"
                address="محله آرژانتین ، خیابان 8، بن بست گل نرگس، پلاک5"
                code="-"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="تهران"
                town="تهران"
                phone="۰۲۱-۸۴۲۲۹۰۰۰-۹۹۹"
                address="خیابان مطهری، اندیشه، کوی نور، کوچه چهارم، پلاک15"
                code="-"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="تهران"
                town="تهران"
                phone="۰۲۱-۸۴۲۲۹۰۰۰-۹۹۹"
                address="میدان فاطمی، روبروی وزارت کشور، خیابان دوم، روبروی بیمه ایران، پلاک13"
                code="-"
                size="laptopdesktop"
              />

              <BranchesTable
                ostan="آذربایجان غربی"
                town="ارومیه"
                phone="0443136"
                phoneSec="09141464126"
                address="بلوار باکری، خیابان نهضت، روبروی پارکینگ اداره برق، پلاک 10 "
                code="402"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="آذربایجان شرقی"
                town="تبریز"
                phone="04133254719-33"
                phoneSec="09143003035"
                address="خیابان چایکنار، نرسیده به کلانتر، نبش کوچه شهیدفاطمی، ساختمان ال کا پی،  طبقه اول"
                code="403"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="اردبیل"
                town="اردبیل"
                phone="09112348847"
                phoneSec=""
                address="چهار راه ژاندارمری،اول کوچه احمدی، ساختمان آراد،طبقه 4"
                code="417"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="اصفهان"
                town="اصفهان"
                phone="۰۳۱-۳۶۲۰۲۴۳۷"
                phoneSec="۰۹۱۲۰۶۹۵۸۰۹"
                address="اصفهان، خیابان وحید، جنب فروشگاه آبی، نبش کوچه ۳۵، ساختمان دنا۲، طبقه اول"
                code="۴۰۶"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="البرز"
                town="کرج"
                phone="09123725426"
                address="گلشهر، پونه شرقی، جنب بیمه معلم، ساختمان برج سفید، طبقه سوم، واحد5"
                code="۴۱۵"
                size="laptopdesktop"
              />
               <BranchesTable
                ostan="البرز"
                town="کرج"
                phone=""
                address="مهرویلا بلوار درختی نبش خ آراسته ساختمان میرداماد طبقه اول واحد3"
                code=""
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="ایلام"
                town="ایلام"
                phone="09101940561"
                phoneSec=""
                address="ایلام:۲۴متری ولیعصر،پنج راه جهاد مجتمع الغدیر ،طبقه اول"
                code="412"
                size="laptopdesktop"
              />

              <BranchesTable
                ostan="بوشهر"
                town="بوشهر"
                phone="077335526"
                phoneSec="09177788001"
                address="بزرگرا طالقانی، خیابان هجرت، نبش خردشرقی، روبروی تراشکاری عادل"
                code="۴۱۶"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="چهارمحال و بختیاری"
                town="شهرکرد"
                phone="03833330629"
                phoneSec="09398877708"
                address="خیابان امین آزاد چهارراه پزشک قانونی یا کوچه نظام پزشکی پلاک 5"
                code="۴۲۴"
                size="laptopdesktop"
              />

              <BranchesTable
                ostan="خراسان رضوی"
                town="مشهد"
                phone="05138520535"
                phoneSec="09126510905"
                address="چهارراه خیام، اول بیستون، مجتمع تک، طبقه4، واحد401"
                code="۴۰۷"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="خراسان رضوی"
                town="مشهد - شعبه درمان"
                phone="05138527527"
                phoneSec="09155106300"
                address="مجتمع زیست خاور، ورودی 1، طبقه منفی 1 ، واحد 2044 و 2045 "
                code="407"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="خراسان شمالی"
                town="بجنورد"
                phone="05832720274"
                phoneSec="09151884179"
                address="خراسان شمالی،خیابان امام خمینی،حدفاصل میدان کارگر و چهاراه قیام ،مجتمع روغنی ،طبقه اول واحد دو"
                code="۴۲۶"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="خراسان جنوبی"
                town="بیرجند"
                phone="09355610901"
                phoneSec=""
                address="بیرجند ، خیابان غفاری، نبش غفاری14"
                code="۴۳۱"
                size="laptopdesktop"
              />
             
               <BranchesTable
                ostan="خوزستان"
                town="اهواز"
                phone=""
                phoneSec=""
                address="امانیه، دز غربی، پلاگ 129 طبقه یک"
                code="۴۲۳"
                size="laptopdesktop"

              />
               <BranchesTable
                ostan="خوزستان"
                town="اهواز"
                phone=""
                phoneSec=""
                address="خیابان اصلی انقلاب، بین شیخ بهاء و ناصر خسرو، پاساژ صدف، پلاک 477"
                code=""
                size="laptopdesktop"

              />
              <BranchesTable
                ostan="زنجان"
                town="زنجان"
                phone="09214916436"
                address="خیابان زینب غربی، نرسیده به مسجد مهدیه، رو به روی پست بانک، ساختمان مهر، طبقه 2، واحد 4"
                code="429"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="سمنان"
                town="سمنان"
                phone="023-33433602-603"
                phoneSec="09123328734"
                address="خیابان سعدی، نبش سعدی 9، طبقه سوم شمالی"
                code="۴۳۷"
                size="laptopdesktop"
              />

              <BranchesTable
                ostan="سیستان و بلوچستان"
                town="زاهدان"
                phone="05433437437"
                phoneSec="09153432414"
                address="بلوار بهداشت ، بین توکلی و بهداشت 15 ، روبروی پارک لاله"
                code="۴۳۰"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="فارس"
                town="شیراز"
                phone="07132359908"
                phoneSec="09171058706"
                address="معدل غربی، روبروی اداره کل آموزش و پرورش، ساختمان سورن، طبقه سوم، واحد 7"
                code="۴۱۴"
                size="laptopdesktop"
              />

              <BranchesTable
                ostan="قزوین"
                town="قزوین"
                phone="9124817973"
                address="چهار راه ولیعصر، روبروی خیابان حکم آباد، مجتمع اداری تجاری توبا، طبقه همکف، پلاک9"
                code="413"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="قم"
                town="قم"
                phone="7758406"
                phoneSec="09126521774"
                address="55 متری عمار یاسر ، نبش کوچه 40 ، ساختمان نخل "
                code="۴۱۹"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="کردستان"
                town="سنندج"
                phone="33565273"
                phoneSec="09188715833"
                address="بلوار شبلی ، خیابان شاهد 6 ، کوچه احد 6، پلاک 28، طبقه اول"
                code="۴۰۵"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="کرمان"
                town="کرمان"
                phone="03432438860-61"
                phoneSec="09131990048"
                address="خیابان امام جمعه، نبش کوچه 20،جنب مرکز بینایی سنجی نگین ساختمان پارس طبقه2، واحد 4"
                code="۴۱۰"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="کرمانشاه"
                town="کرمانشاه"
                phone="08338258237-9"
                phoneSec="09183301894"
                address="میدان آزادی، پشت داروخانه رازی"
                code="۴۰۴"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="کهکیلویه و بویر احمد"
                town="یاسوج"
                phone="07433232104"
                phoneSec="09930139686"
                address="نبش معلم 5 ، پاساژ گلها، طبقه دوم،شرکت ایرانیان پوشش "
                code="۴۲۱"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="گلستان"
                town="گرگان"
                phone="01732222166"
                phoneSec="09111754708"
                address="خیابان شریعتی، (سر خواجه)، مجتمع آفتاب3، طبقه2، واحد209"
                code="۴۰۸"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="گیلان"
                town="رشت"
                phone="01391007170"
                phoneSec="09332398967"
                address="رشت-خیابان هفده شهریور-پشت دادگستری چله خانه-به سمت بیمارستان امیرالمونین-نبش کوچه رسولی-ساختمان یادگار-طبقه ۲"
                code="۴۲۰"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="لرستان"
                town="خرم آباد	"
                phone="06633400986"
                phoneSec="09124231741"
                address="میدان شقایق، منار آجری، بالاتر از بیمه پارسیان، پلاک ۱۱۹"
                code="۴۰۹"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="مازندران"
                town="ساری"
                phone="09113209819"
                address="مازندران، ساری، خیابان امیر مازندرانی، میدان کارگر، جنب داروخانه رنجبر، ساختمان امام صادق، طبقه4، واحد5"
                code="۴۲۵"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="مرکزی"
                town="اراک"
                phone="08634655255"
                address="انتهای خیابان دانشگاه-جنب شیرینی باباقناد-مجتمع آرسام-طبقه سوم-واحد ۱۰"
                code="۴۲۷"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="هرمزگان"
                town="بندرعباس"
                phone="07633754860"
                phoneSec="09173613177"
                address="رسالت شمالی، 13هکتاری(کوی ولایت)، روبروی اداره کل بانوان، کوچه رودکی، ابتدای کوچه، طبقه چهارم"
                code="۴۲۲"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="هرمزگان"
                town="بندرعباس"
                phone="-"
                phoneSec="-"
                address="بندرعباس سه راه جهانبار،بلوار جمهوری اسلامی،ابتدای کمربندی،ساختمان نگار"
                code="-"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="هرمزگان"
                town="قشم"
                phone="-"
                phoneSec="-"
                address="بلوار ولی عصر، نرسیده به چهارراه پردیس، پلاک10، طبقه2، واحد4"
                code="-"
                size="laptopdesktop"
              />

              <BranchesTable
                ostan="همدان"
                town="همدان"
                phone="08138253327-6-8253300"
                phoneSec="09188102757"
                address="همدان ،خیابان طالقانی ، نبش چهارراه ابن سینا ، روبروی آموزش پرورش ناحیه دو ،  پلاک 246 ، طبقه اول"
                code="۴۱۸"
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="همدان"
                town="همدان"
                phone=""
                phoneSec=""
                address="میدان فلسطین، خیابان فلسطین،روبروی پمپ بنزین فلسطین، پایین تر از هتل خاتم، پلاک 15"
                code=""
                size="laptopdesktop"
              />
              <BranchesTable
                ostan="یزد"
                town="یزد"
                phone="03537265773"
                phoneSec="09132509756"
                address="میدان امام علی، ابتدای خیابان پارساییان، جنب اداره راه (خیابان حیدر)"
                code="۴۱۱"
                size="laptopdesktop"
              />
            </table>
          </div>
        </Col>
        <Col span={2}></Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
    <div className="BranchesBackground">
      <div style={{ paddingTop: "100px" }}>
        <Center>
          <p
            className="mainTitleTablet mainTitleBorderRight mainTitleBorderLeft"
            style={{ color: "#fff" }}
          >
            <strong>شعب ایرانیان پوشش</strong>
          </p>
        </Center>
        <Center>
          <Margin top={2}>
            <p className="mainTitleDescriptionTablet" style={{ color: "#fff" }}>
              فهرست شعبه های زیرمجوعه ایرانیان پوشش
            </p>
          </Margin>
        </Center>
      </div>
      <Row style={{ marginTop: "100px" }}>
        <Col span={1}></Col>
        <Col span={22}>
          <div style={branchesCard}>
            <table
              style={{
                fontFamily: "IranSans",
                borderCollapse: "separate",
                borderSpacing: "0 15px",
                paddingRight: "10px",
                paddingLeft: "10px",
              }}
            >
              <tr>
                <th style={thTable}>کد</th>
                <th style={thTable}>آدرس</th>
                <th style={thTable}>تلفن</th>
                <th style={thTable}>شهرستان</th>
                <th style={thTable}>استان</th>
              </tr>

              <BranchesTable
                ostan="تهران (شعبه مرکزی)"
                town="تهران"
                phone="۰۲۱-۸۴۲۲۹۰۰۰-۹۹۹"
                address="خیابان سیدجمال الدین اسدآبادی (یوسف آباد)، بن بست هفتم، پلاک ۱۴، ساختمان شرکت سهامی ایرانیان پوشش"
                code="400"
                size="tablet"
              />
               <BranchesTable
                ostan="تهران"
                town="تهران"
                phone="۰۲۱-۸۴۲۲۹۰۰۰-۹۹۹"
                address="خیابان ولیعصر، خیابان سید جمال الدین اسدآبادی(یوسف آباد) نبش کوچه چهارم پلاک 44"
                code=""
                size="tablet"
              />
              <BranchesTable
                ostan="تهران"
                town="تهران"
                phone="۰۲۱-۸۴۲۲۹۰۰۰-۹۹۹"
                address="خ ولیعصر یوسف آباد میدان سلماس خ شهریار نبش کوچه 14(سپهری) پلاک 39"
                code="-"
                size="tablet"
              />
              <BranchesTable
                ostan="تهران"
                town="تهران"
                phone="۰۲۱-۸۴۲۲۹۰۰۰-۹۹۹"
                address="محله آرژانتین ، خیابان 8، بن بست گل نرگس، پلاک5"
                code="-"
                size="tablet"
              />
              <BranchesTable
                ostan="تهران"
                town="تهران"
                phone="۰۲۱-۸۴۲۲۹۰۰۰-۹۹۹"
                address="خیابان مطهری، اندیشه، کوی نور، کوچه چهارم، پلاک15"
                code="-"
                size="tablet"
              />
              <BranchesTable
                ostan="تهران"
                town="تهران"
                phone="۰۲۱-۸۴۲۲۹۰۰۰-۹۹۹"
                address="میدان فاطمی، روبروی وزارت کشور، خیابان دوم، روبروی بیمه ایران، پلاک13"
                code="-"
                size="tablet"
              />
              <BranchesTable
                ostan="آذربایجان غربی"
                town="ارومیه"
                phone="0443136"
                phoneSec="09141464126"
                address="بلوار باکری، خیابان نهضت، روبروی پارکینگ اداره برق، پلاک 10 "
                code="402"
                size="tablet"
              />
              <BranchesTable
                ostan="آذربایجان شرقی"
                town="تبریز"
                phone="04133254719-33"
                phoneSec="09143003035"
                address="خیابان چایکنار، نرسیده به کلانتر، نبش کوچه شهیدفاطمی، ساختمان ال کا پی،  طبقه اول"
                code="403"
                size="tablet"
              />
              <BranchesTable
                ostan="اردبیل"
                town="اردبیل"
                phone="09112348847"
                phoneSec=""
                address="چهار راه ژاندارمری،اول کوچه احمدی، ساختمان آراد،طبقه 4"
                code="417"
                size="tablet"
              />
              <BranchesTable
                ostan="اصفهان"
                town="اصفهان"
                phone="۰۳۱-۳۶۲۰۲۴۳۷"
                phoneSec="۰۹۱۲۰۶۹۵۸۰۹"
                address="اصفهان، خیابان وحید، جنب فروشگاه آبی، نبش کوچه ۳۵، ساختمان دنا۲، طبقه اول"
                code="۴۰۶"
                size="tablet"
              />
              <BranchesTable
                ostan="البرز"
                town="کرج"
                phone="09123725426"
                address="گلشهر، پونه شرقی، جنب بیمه معلم، ساختمان برج سفید، طبقه سوم، واحد5"
                code="۴۱۵"
                size="tablet"
              />
                <BranchesTable
                ostan="البرز"
                town="کرج"
                phone=""
                address="مهرویلا بلوار درختی نبش خ آراسته ساختمان میرداماد طبقه اول واحد3"
                code=""
                size="tablet"
              />
              <BranchesTable
                ostan="ایلام"
                town="ایلام"
                phone="09101940561"
                phoneSec=""
                address="ایلام:۲۴متری ولیعصر،پنج راه جهاد مجتمع الغدیر ،طبقه اول"
                code="412"
                size="tablet"
              />

              <BranchesTable
                ostan="بوشهر"
                town="بوشهر"
                phone="077335526"
                phoneSec="09177788001"
                address="بزرگرا طالقانی، خیابان هجرت، نبش خردشرقی، روبروی تراشکاری عادل"
                code="۴۱۶"
                size="tablet"
              />
              <BranchesTable
                ostan="چهارمحال و بختیاری"
                town="شهرکرد"
                phone="03833330629"
                phoneSec="09398877708"
                address="خیابان امین آزاد چهارراه پزشک قانونی یا کوچه نظام پزشکی پلاک 5"
                code="۴۲۴"
                size="tablet"
              />

              <BranchesTable
                ostan="خراسان رضوی"
                town="مشهد"
                phone="05138520535"
                phoneSec="09126510905"
                address="چهارراه خیام، اول بیستون، مجتمع تک، طبقه4، واحد401"
                code="۴۰۷"
                size="tablet"
              />
              <BranchesTable
                ostan="خراسان رضوی"
                town="مشهد - شعبه درمان"
                phone="05138527527"
                phoneSec="09155106300"
                address="مجتمع زیست خاور، ورودی 1، طبقه منفی 1 ، واحد 2044 و 2045 "
                code="407"
                size="tablet"
              />
              <BranchesTable
                ostan="خراسان شمالی"
                town="بجنورد"
                phone="05832720274"
                phoneSec="09151884179"
                address="خراسان شمالی،خیابان امام خمینی،حدفاصل میدان کارگر و چهاراه قیام ،مجتمع روغنی ،طبقه اول واحد دو"
                code="۴۲۶"
                size="tablet"
              />
              <BranchesTable
                ostan="خراسان جنوبی"
                town="بیرجند"
                phone="09355610901"
                phoneSec=""
                address="بیرجند ، خیابان غفاری، نبش غفاری14"
                code="۴۳۱"
                size="tablet"
              />
              <BranchesTable
                ostan="خوزستان"
                town="اهواز"
                phone=""
                phoneSec=""
                address="امانیه، دز غربی، پلاگ 129 طبقه یک"
                code="۴۲۳"
                size="tablet"

              />
               <BranchesTable
                ostan="خوزستان"
                town="اهواز"
                phone=""
                phoneSec=""
                address="خیابان اصلی انقلاب، بین شیخ بهاء و ناصر خسرو، پاساژ صدف، پلاک 477"
                code=""
                size="tablet"

              />
              <BranchesTable
                ostan="زنجان"
                town="زنجان"
                phone="09214916436"
                address="خیابان زینب غربی، نرسیده به مسجد مهدیه، رو به روی پست بانک، ساختمان مهر، طبقه 2، واحد 4"
                code="429"
                size="tablet"
              />
              <BranchesTable
                ostan="سمنان"
                town="سمنان"
                phone="023-33433602-603"
                phoneSec="09123328734"
                address="خیابان سعدی، نبش سعدی 9، طبقه سوم شمالی"
                code="۴۳۷"
                size="tablet"
              />

              <BranchesTable
                ostan="سیستان و بلوچستان"
                town="زاهدان"
                phone="05433437437"
                phoneSec="09153432414"
                address="بلوار بهداشت ، بین توکلی و بهداشت 15 ، روبروی پارک لاله"
                code="۴۳۰"
                size="tablet"
              />
              <BranchesTable
                ostan="فارس"
                town="شیراز"
                phone="07132359908"
                phoneSec="09171058706"
                address="معدل غربی، روبروی اداره کل آموزش و پرورش، ساختمان سورن، طبقه سوم، واحد 7"
                code="۴۱۴"
                size="tablet"
              />

              <BranchesTable
                ostan="قزوین"
                town="قزوین"
                phone="9124817973"
                address="چهار راه ولیعصر، روبروی خیابان حکم آباد، مجتمع اداری تجاری توبا، طبقه همکف، پلاک9"
                code="413"
                size="tablet"
              />
              <BranchesTable
                ostan="قم"
                town="قم"
                phone="7758406"
                phoneSec="09126521774"
                address="55 متری عمار یاسر ، نبش کوچه 40 ، ساختمان نخل "
                code="۴۱۹"
                size="tablet"
              />
              <BranchesTable
                ostan="کردستان"
                town="سنندج"
                phone="33565273"
                phoneSec="09188715833"
                address="بلوار شبلی ، خیابان شاهد 6 ، کوچه احد 6، پلاک 28، طبقه اول"
                code="۴۰۵"
                size="tablet"
              />
              <BranchesTable
                ostan="کرمان"
                town="کرمان"
                phone="03432438860-61"
                phoneSec="09131990048"
                address="خیابان امام جمعه، نبش کوچه 20،جنب مرکز بینایی سنجی نگین ساختمان پارس طبقه2، واحد 4"
                code="۴۱۰"
                size="tablet"
              />
              <BranchesTable
                ostan="کرمانشاه"
                town="کرمانشاه"
                phone="08338258237-9"
                phoneSec="09183301894"
                address="میدان آزادی، پشت داروخانه رازی"
                code="۴۰۴"
                size="tablet"
              />
              <BranchesTable
                ostan="کهکیلویه و بویر احمد"
                town="یاسوج"
                phone="07433232104"
                phoneSec="09930139686"
                address="نبش معلم 5 ، پاساژ گلها، طبقه دوم،شرکت ایرانیان پوشش "
                code="۴۲۱"
                size="tablet"
              />
              <BranchesTable
                ostan="گلستان"
                town="گرگان"
                phone="01732222166"
                phoneSec="09111754708"
                address="خیابان شریعتی، (سر خواجه)، مجتمع آفتاب3، طبقه2، واحد209"
                code="۴۰۸"
                size="tablet"
              />
             <BranchesTable
                ostan="گیلان"
                town="رشت"
                phone="01391007170"
                phoneSec="09332398967"
                address="رشت-خیابان هفده شهریور-پشت دادگستری چله خانه-به سمت بیمارستان امیرالمونین-نبش کوچه رسولی-ساختمان یادگار-طبقه ۲"
                code="۴۲۰"
                size="tablet"
              />
              <BranchesTable
                ostan="لرستان"
                town="خرم آباد	"
                phone="06633400986"
                phoneSec="09124231741"
                address="میدان شقایق، منار آجری، بالاتر از بیمه پارسیان، پلاک ۱۱۹"
                code="۴۰۹"
                size="tablet"
              />
              <BranchesTable
                ostan="مازندران"
                town="ساری"
                phone="09113209819"
                address="مازندران، ساری، خیابان امیر مازندرانی، میدان کارگر، جنب داروخانه رنجبر، ساختمان امام صادق، طبقه4، واحد5"
                code="۴۲۵"
                size="tablet"
              />
              <BranchesTable
                ostan="مرکزی"
                town="اراک"
                phone="08634655255"
                address="انتهای خیابان دانشگاه-جنب شیرینی باباقناد-مجتمع آرسام-طبقه سوم-واحد ۱۰"
                code="۴۲۷"
                size="tablet"
              />
              <BranchesTable
                ostan="هرمزگان"
                town="بندرعباس"
                phone="07633754860"
                phoneSec="09173613177"
                address="رسالت شمالی، 13هکتاری(کوی ولایت)، روبروی اداره کل بانوان، کوچه رودکی، ابتدای کوچه، طبقه چهارم"
                code="۴۲۲"
                size="tablet"
              />
              <BranchesTable
                ostan="هرمزگان"
                town="بندرعباس"
                phone="-"
                phoneSec="-"
                address="بندرعباس سه راه جهانبار،بلوار جمهوری اسلامی،ابتدای کمربندی،ساختمان نگار"
                code="-"
                size="tablet"
              />
              <BranchesTable
                ostan="هرمزگان"
                town="قشم"
                phone="-"
                phoneSec="-"
                address="بلوار ولی عصر، نرسیده به چهارراه پردیس، پلاک10، طبقه2، واحد4"
                code="-"
                size="tablet"
              />

              <BranchesTable
                ostan="همدان"
                town="همدان"
                phone="08138253327-6-8253300"
                phoneSec="09188102757"
                address="همدان ،خیابان طالقانی ، نبش چهارراه ابن سینا ، روبروی آموزش پرورش ناحیه دو ،  پلاک 246 ، طبقه اول"
                code="۴۱۸"
                size="tablet"
              />
              <BranchesTable
                ostan="همدان"
                town="همدان"
                phone=""
                phoneSec=""
                address="میدان فلسطین، خیابان فلسطین،روبروی پمپ بنزین فلسطین، پایین تر از هتل خاتم، پلاک 15"
                code=""
                size="tablet"
              />
              <BranchesTable
                ostan="یزد"
                town="یزد"
                phone="03537265773"
                phoneSec="09132509756"
                address="میدان امام علی، ابتدای خیابان پارساییان، جنب اداره راه (خیابان حیدر)"
                code="۴۱۱"
                size="tablet"
              />
            </table>
          </div>
        </Col>
        <Col span={1}></Col>
      </Row>
    </div>
  ) : (
    <div className="BranchesBackground">
      <div style={{ paddingTop: "50px" }}>
        <Center>
          <p className="mainTitleMobile mainTitleBorderRightMobile mainTitleBorderLeftMobile">
            <strong>شعب ایرانیان پوشش</strong>
          </p>
        </Center>
        <Center>
          <Margin top={2}>
            <p className="mainTitleDescriptionMobile" style={{ color: "#fff" }}>
              فهرست شعبه های زیرمجوعه ایرانیان پوشش
            </p>
          </Margin>
        </Center>
      </div>
      <Row style={{ marginTop: "25px" }}>
        <Col span={1}></Col>
        <Col span={22}>
          <div style={branchesCard}>
            <table
              style={{
                fontFamily: "IranSans",
                borderCollapse: "separate",
                borderSpacing: "0 15px",
                paddingRight: "10px",
                paddingLeft: "10px",
              }}
            >
              <tr>
                <th style={thTableMobile}>کد</th>
                <th style={thTableMobile}>آدرس</th>
                <th style={thTableMobile}>تلفن</th>
                <th style={thTableMobile}>شهرستان</th>
                <th style={thTableMobile}>استان</th>
              </tr>

              <BranchesTable
                ostan="تهران (شعبه مرکزی)"
                town="تهران"
                phone="۰۲۱-۸۴۲۲۹۰۰۰-۹۹۹"
                address="خیابان سیدجمال الدین اسدآبادی (یوسف آباد)، بن بست هفتم، پلاک ۱۴، ساختمان شرکت سهامی ایرانیان پوشش"
                code="400"
              />
               <BranchesTable
                ostan="تهران"
                town="تهران"
                phone="۰۲۱-۸۴۲۲۹۰۰۰-۹۹۹"
                address="خیابان ولیعصر، خیابان سید جمال الدین اسدآبادی(یوسف آباد) نبش کوچه چهارم پلاک 44"
                code=""
              />
              <BranchesTable
                ostan="تهران"
                town="تهران"
                phone="۰۲۱-۸۴۲۲۹۰۰۰-۹۹۹"
                address="خ ولیعصر یوسف آباد میدان سلماس خ شهریار نبش کوچه 14(سپهری) پلاک 39"
                code="-"
              />
              <BranchesTable
                ostan="تهران"
                town="تهران"
                phone="۰۲۱-۸۴۲۲۹۰۰۰-۹۹۹"
                address="محله آرژانتین ، خیابان 8، بن بست گل نرگس، پلاک5"
                code="-"
              />
              <BranchesTable
                ostan="تهران"
                town="تهران"
                phone="۰۲۱-۸۴۲۲۹۰۰۰-۹۹۹"
                address="خیابان مطهری، اندیشه، کوی نور، کوچه چهارم، پلاک15"
                code="-"
              />
              <BranchesTable
                ostan="تهران"
                town="تهران"
                phone="۰۲۱-۸۴۲۲۹۰۰۰-۹۹۹"
                address="میدان فاطمی، روبروی وزارت کشور، خیابان دوم، روبروی بیمه ایران، پلاک13"
                code="-"
              />
              <BranchesTable
                ostan="آذربایجان غربی"
                town="ارومیه"
                phone="0443136"
                phoneSec="09141464126"
                address="بلوار باکری، خیابان نهضت، روبروی پارکینگ اداره برق، پلاک 10 "
                code="402"
              />
              <BranchesTable
                ostan="آذربایجان شرقی"
                town="تبریز"
                phone="04133254719-33"
                phoneSec="09143003035"
                address="خیابان چایکنار، نرسیده به کلانتر، نبش کوچه شهیدفاطمی، ساختمان ال کا پی،  طبقه اول"
                code="403"
              />
              <BranchesTable
                ostan="اردبیل"
                town="اردبیل"
                phone="09112348847"
                phoneSec=""
                address="چهار راه ژاندارمری،اول کوچه احمدی، ساختمان آراد،طبقه 4"
                code="417"
              />
              <BranchesTable
                ostan="اصفهان"
                town="اصفهان"
                phone="۰۳۱-۳۶۲۰۲۴۳۷"
                phoneSec="۰۹۱۲۰۶۹۵۸۰۹"
                address="اصفهان، خیابان وحید، جنب فروشگاه آبی، نبش کوچه ۳۵، ساختمان دنا۲، طبقه اول"
                code="۴۰۶"
              />
              <BranchesTable
                ostan="البرز"
                town="کرج"
                phone="09123725426"
                address="گلشهر، پونه شرقی، جنب بیمه معلم، ساختمان برج سفید، طبقه سوم، واحد5"
                code="۴۱۵"
              />
                <BranchesTable
                ostan="البرز"
                town="کرج"
                phone=""
                address="مهرویلا بلوار درختی نبش خ آراسته ساختمان میرداماد طبقه اول واحد3"
                code=""
              />
              <BranchesTable
                ostan="ایلام"
                town="ایلام"
                phone="09101940561"
                phoneSec=""
                address="ایلام:۲۴متری ولیعصر،پنج راه جهاد مجتمع الغدیر ،طبقه اول"
                code="412"
              />

              <BranchesTable
                ostan="بوشهر"
                town="بوشهر"
                phone="077335526"
                phoneSec="09177788001"
                address="بزرگرا طالقانی، خیابان هجرت، نبش خردشرقی، روبروی تراشکاری عادل"
                code="۴۱۶"
              />
              <BranchesTable
                ostan="چهارمحال و بختیاری"
                town="شهرکرد"
                phone="03833330629"
                phoneSec="09398877708"
                address="خیابان امین آزاد چهارراه پزشک قانونی یا کوچه نظام پزشکی پلاک 5"
                code="۴۲۴"
              />

              <BranchesTable
                ostan="خراسان رضوی"
                town="مشهد"
                phone="05138520535"
                phoneSec="09126510905"
                address="چهارراه خیام، اول بیستون، مجتمع تک، طبقه4، واحد401"
                code="۴۰۷"
              />
              <BranchesTable
                ostan="خراسان رضوی"
                town="مشهد - شعبه درمان"
                phone="05138527527"
                phoneSec="09155106300"
                address="مجتمع زیست خاور، ورودی 1، طبقه منفی 1 ، واحد 2044 و 2045 "
                code="407"
              />
              <BranchesTable
                ostan="خراسان شمالی"
                town="بجنورد"
                phone="05832720274"
                phoneSec="09151884179"
                address="خراسان شمالی،خیابان امام خمینی،حدفاصل میدان کارگر و چهاراه قیام ،مجتمع روغنی ،طبقه اول واحد دو"
                code="۴۲۶"
              />
              <BranchesTable
                ostan="خراسان جنوبی"
                town="بیرجند"
                phone="09355610901"
                phoneSec=""
                address="بیرجند ، خیابان غفاری، نبش غفاری14"
                code="۴۳۱"
              />
              <BranchesTable
                ostan="خوزستان"
                town="اهواز"
                phone=""
                phoneSec=""
                address="امانیه، دز غربی، پلاگ 129 طبقه یک"
                code="۴۲۳"
              />
               <BranchesTable
                ostan="خوزستان"
                town="اهواز"
                phone=""
                phoneSec=""
                address="خیابان اصلی انقلاب، بین شیخ بهاء و ناصر خسرو، پاساژ صدف، پلاک 477"
                code=""
              />
              <BranchesTable
                ostan="زنجان"
                town="زنجان"
                phone="09214916436"
                address="خیابان زینب غربی، نرسیده به مسجد مهدیه، رو به روی پست بانک، ساختمان مهر، طبقه 2، واحد 4"
                code="429"
              />
              <BranchesTable
                ostan="سمنان"
                town="سمنان"
                phone="023-33433602-603"
                phoneSec="09123328734"
                address="خیابان سعدی، نبش سعدی 9، طبقه سوم شمالی"
                code="۴۳۷"
              />

              <BranchesTable
                ostan="سیستان و بلوچستان"
                town="زاهدان"
                phone="05433437437"
                phoneSec="09153432414"
                address="بلوار بهداشت ، بین توکلی و بهداشت 15 ، روبروی پارک لاله"
                code="۴۳۰"
              />
              <BranchesTable
                ostan="فارس"
                town="شیراز"
                phone="07132359908"
                phoneSec="09171058706"
                address="معدل غربی، روبروی اداره کل آموزش و پرورش، ساختمان سورن، طبقه سوم، واحد 7"
                code="۴۱۴"
              />

              <BranchesTable
                ostan="قزوین"
                town="قزوین"
                phone="9124817973"
                address="چهار راه ولیعصر، روبروی خیابان حکم آباد، مجتمع اداری تجاری توبا، طبقه همکف، پلاک9"
                code="413"
              />
              <BranchesTable
                ostan="قم"
                town="قم"
                phone="7758406"
                phoneSec="09126521774"
                address="55 متری عمار یاسر ، نبش کوچه 40 ، ساختمان نخل "
                code="۴۱۹"
              />
              <BranchesTable
                ostan="کردستان"
                town="سنندج"
                phone="33565273"
                phoneSec="09188715833"
                address="بلوار شبلی ، خیابان شاهد 6 ، کوچه احد 6، پلاک 28، طبقه اول"
                code="۴۰۵"
              />
              <BranchesTable
                ostan="کرمان"
                town="کرمان"
                phone="03432438860-61"
                phoneSec="09131990048"
                address="خیابان امام جمعه، نبش کوچه 20،جنب مرکز بینایی سنجی نگین ساختمان پارس طبقه2، واحد 4"
                code="۴۱۰"
              />
              <BranchesTable
                ostan="کرمانشاه"
                town="کرمانشاه"
                phone="08338258237-9"
                phoneSec="09183301894"
                address="میدان آزادی، پشت داروخانه رازی"
                code="۴۰۴"
              />
              <BranchesTable
                ostan="کهکیلویه و بویر احمد"
                town="یاسوج"
                phone="07433232104"
                phoneSec="09930139686"
                address="نبش معلم 5 ، پاساژ گلها، طبقه دوم،شرکت ایرانیان پوشش "
                code="۴۲۱"
              />
              <BranchesTable
                ostan="گلستان"
                town="گرگان"
                phone="01732222166"
                phoneSec="09111754708"
                address="خیابان شریعتی، (سر خواجه)، مجتمع آفتاب3، طبقه2، واحد209"
                code="۴۰۸"
              />
              <BranchesTable
                ostan="گیلان"
                town="رشت"
                phone="01391007170"
                phoneSec="09332398967"
                address="رشت-خیابان هفده شهریور-پشت دادگستری چله خانه-به سمت بیمارستان امیرالمونین-نبش کوچه رسولی-ساختمان یادگار-طبقه ۲"
                code="۴۲۰"
              />
              <BranchesTable
                ostan="لرستان"
                town="خرم آباد	"
                phone="06633400986"
                phoneSec="09124231741"
                address="میدان شقایق، منار آجری، بالاتر از بیمه پارسیان، پلاک ۱۱۹"
                code="۴۰۹"
              />
              <BranchesTable
                ostan="مازندران"
                town="ساری"
                phone="09113209819"
                address="مازندران، ساری، خیابان امیر مازندرانی، میدان کارگر، جنب داروخانه رنجبر، ساختمان امام صادق، طبقه4، واحد5"
                code="۴۲۵"
              />
              <BranchesTable
                ostan="مرکزی"
                town="اراک"
                phone="08634655255"
                address="انتهای خیابان دانشگاه-جنب شیرینی باباقناد-مجتمع آرسام-طبقه سوم-واحد ۱۰"
                code="۴۲۷"
              />
              <BranchesTable
                ostan="هرمزگان"
                town="بندرعباس"
                phone="07633754860"
                phoneSec="09173613177"
                address="رسالت شمالی، 13هکتاری(کوی ولایت)، روبروی اداره کل بانوان، کوچه رودکی، ابتدای کوچه، طبقه چهارم"
                code="۴۲۲"
              />
              <BranchesTable
                ostan="هرمزگان"
                town="بندرعباس"
                phone="-"
                phoneSec="-"
                address="بندرعباس سه راه جهانبار،بلوار جمهوری اسلامی،ابتدای کمربندی،ساختمان نگار"
                code="-"
              />
              <BranchesTable
                ostan="هرمزگان"
                town="قشم"
                phone="-"
                phoneSec="-"
                address="بلوار ولی عصر، نرسیده به چهارراه پردیس، پلاک10، طبقه2، واحد4"
                code="-"
              />

              <BranchesTable
                ostan="همدان"
                town="همدان"
                phone="08138253327-6-8253300"
                phoneSec="09188102757"
                address="همدان ،خیابان طالقانی ، نبش چهارراه ابن سینا ، روبروی آموزش پرورش ناحیه دو ،  پلاک 246 ، طبقه اول"
                code="۴۱۸"
              />
              <BranchesTable
                ostan="همدان"
                town="همدان"
                phone=""
                phoneSec=""
                address="میدان فلسطین، خیابان فلسطین،روبروی پمپ بنزین فلسطین، پایین تر از هتل خاتم، پلاک 15"
                code=""
              />
              <BranchesTable
                ostan="یزد"
                town="یزد"
                phone="03537265773"
                phoneSec="09132509756"
                address="میدان امام علی، ابتدای خیابان پارساییان، جنب اداره راه (خیابان حیدر)"
                code="۴۱۱"
              />
            </table>
          </div>
        </Col>
        <Col span={1}></Col>
      </Row>
    </div>
  );
};

export default BranchesMain;
